import app from '$$app';
import log from '$$log';
import constantsCommon from '$$helpers/constants';
import CustomColumns from './customColumns';
import UserColumns from './userColumns';
import CommonColumns from './commonColumns';
import ActionColumns from './actionColumns';
import Config from '../../config';
import ColumnsConfig from './columnsConfig';
import UiManager from './uiManager';
import ColumnsBar from '../../../columnsConfigBar/columnsBar';
import { verifyColumnsOrder } from './helpers';

class Columns {
  #projectConfig = null;

  #instance = null;

  init(instance, projectConfig) {
    this.#instance = instance;
    this.#projectConfig = projectConfig;

    ColumnsConfig.init(instance, projectConfig); // Initing columns config from projectConfig.initGridColumns
    UiManager.init(instance);

    this.#initColumns(); // Adds default columns, user columns, custom columns and action column to gantt.config.columns
    this.#configureColumns(); // Set columns width, visibility, order and set grid width according to columns width

    ColumnsBar.initGanttColumns(this.#instance.config.columns, ColumnsConfig.config); // Set columns settings to Vue columns sidebar
  }

  changeUserCustomColumn(action, columnId, isShow = false) {
    this.#instance.config.columns = _.filter(this.#instance.config.columns, column => !column.isUserCustomColumn);
    UserColumns.init(this.#instance);

    if (action && columnId) {
      _.each(this.#instance.config.columns, column => {
        if (column.isUserCustomColumn) {
          if ((action === 'create' || action === 'update') && +column.name === +columnId) {
            const wasShow = ColumnsConfig.config[column.name];

            ColumnsConfig.config[column.name] = wasShow || isShow;
          }
        }
      });

      if (action === 'delete') {
        delete ColumnsConfig.config[columnId];
        delete ColumnsConfig.config.sizes[columnId];
      }
    }

    const columnsOrder = this.#instance.config.columns.map(column => column.name);

    ColumnsConfig.setColumnsOrder(verifyColumnsOrder(columnsOrder), true);
    ColumnsConfig.checkColumnsVisibilityAndOrder(true);

    ColumnsBar.initGanttColumns(this.#instance.config.columns, ColumnsConfig.config);
  }

  changeColumnCheckbox(columnId, value, isAdvanced) {
    if (isAdvanced) {
      ColumnsConfig.changeAdvancedOption(columnId, value);
    } else if (value) {
      ColumnsConfig.showColumn(columnId)
    } else {
      ColumnsConfig.hideColumn(columnId);
    }

    ColumnsBar.initGanttColumns(this.#instance.config.columns, ColumnsConfig.config);
  }

  onGridHeaderClick(event) {
    const cell = event.target.closest('.gantt_grid_head_cell');

    if (cell.classList.contains('gantt_grid_head_buttons')) {
      app.trigger('columnsBar:open', {
        view: 'columns',
        activeTab: 'standartColumns',
        target: 'grid',
      });

      return;
    }

    if (event.target.parentNode.classList?.contains('hide_column_button') || event.target.closest('.hide_column_button')) {
      const columnId = cell.getAttribute('data-column-id');

      cell.style.opacity = '0.5';
      cell.style.pointerEvents = 'none';
      ColumnsConfig.hideColumn(columnId);
      app.trigger('closeColumnFromGridHeader', columnId);
      const t = log.time('ganttRender.instance');
      this.#instance.render();
      t.end();
    }
  }

  onDataRender() {
    UiManager.updateColumnsHeaders();
  }

  onColumnResizeStart() {
    UiManager.toggleColumnsHeadersControlls(true);


    this.#instance.callEvent("onEmptyClick")
  }

  onColumnResizeEnd(columnIndex, column, newWidth) {
    ColumnsConfig.setColumnNewWidth(column, newWidth);
    UiManager.toggleColumnsHeadersControlls(false);
  }

  onGridResizeEnd(oldWidth, newWidth) {
    ColumnsConfig.setGridNewWidth(newWidth);

    if (this.#instance.ganttDataApi.isBase()) {
      UiManager.updateColumnsHeaders();
    }
  }

  onBeforeColumnDragStart(draggedData) {
    if (constantsCommon.COLUMN_ORDER.NOT_DRAGABLE.includes(draggedData.draggedColumn.name)) {
      return false;
    }

    UiManager.toggleColumnsHeadersControlls(true);
    UiManager.toggleCellsOpacity(draggedData, true);

    return true;
  }

  onColumnDragMove(draggedData) {
    if (constantsCommon.COLUMN_ORDER.NOT_MOVABLE_AFTER.includes(draggedData.targetColumn.name)) {
      return false;
    }
    this.#instance.callEvent("onEmptyClick")
    UiManager.addTargetMarkerLong();

    return true;
  }

  onBeforeColumnReorder(draggedData) {
    UiManager.toggleCellsOpacity(draggedData, false);
    UiManager.removeTargetMarkerLong();
    UiManager.toggleColumnsHeadersControlls(false);

    return !constantsCommon.COLUMN_ORDER.NOT_DROPABLE_BEFORE.includes(draggedData.targetColumn.name);
  }

  onAfterColumnReorder() {
    const newOrder = this.#instance.config.columns.map(column => column.name);

    ColumnsConfig.setColumnsOrder(newOrder, true);
  }

  #initColumns() {
    CommonColumns.init(this.#instance); // default columns
    CustomColumns.init(this.#instance); // status, priority, jira_key
    UserColumns.init(this.#instance); // user created custom columns

    if(!this.#instance.ganttDataApi.isHistory()) {
      ActionColumns.init(this.#instance); // here is only one column (action)
    }
  }

  #configureColumns() {
    ColumnsConfig.setColumnsWidth();
    ColumnsConfig.checkColumnsVisibilityAndOrder();
    Config.setConfigParameter('grid_width', ColumnsConfig.getTotalColumnsWidth(), false);
  }
}

export default new Columns();
